import filterPermissions from './filter-permissions';
import { TeamPermission } from '../types/permissions';

const filterTeamPermissions = (isAdmin: boolean) => (teamPermission: TeamPermission) => {
  // Filter out specifically-disallowed permissions
  if (!teamPermission.allowed) {
    return false;
  }

  if (!teamPermission.permission) return false;
  return filterPermissions(teamPermission.permission, isAdmin);
};

export default filterTeamPermissions;
